import ReputationMgmt from '../../ReputationMgmt';

function ReputationMgmtTab() {
  return <ReputationMgmt />;
}

export default ReputationMgmtTab;
